// extracted by mini-css-extract-plugin
export var hoverSwitcher = "styles-module--hoverSwitcher--7c4c3";
export var hoverSwitcherAlt = "styles-module--hoverSwitcherAlt--98d63";
export var hoverSwitcherDefault = "styles-module--hoverSwitcherDefault--9bce9";
export var wrapper = "styles-module--wrapper--73ec3";